const MODULE_MAP: Record<string, string> = {
  'users-management': 'UM',
  'front-office': 'FO',
  'back-office': 'BO',
  'accounting-and-finance': 'ABK',
  'point-of-sale': 'POS',
};

export const useCurrentModule = () => {
  const pathname = window.location.pathname.split('/')[1];

  return MODULE_MAP[pathname];
};

export const getCurrentModule = (pathname?: string) => {
  const segment = pathname ?? window.location.pathname.split('/')[1];

  return MODULE_MAP[segment];
};
